import { Tooltip } from '@app/components/various/Tooltip';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import React from 'react';

interface Props {
  children?: string;
}

export const VariantLabel = React.memo(({ children }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const isOverflowing = useIsOverflowing(ref, { widthOnly: true });

  if (!isDefined(children) || isEmpty(children)) {
    return;
  }

  return (
    <Tooltip content={isOverflowing && children} disableOnTouchScreen>
      <div ref={ref} className="truncate text-center body-6">
        {children}
      </div>
    </Tooltip>
  );
});
